import turfBbox from '@turf/bbox'
import { AllGeoJSON } from '@turf/helpers'
import { Map as MapboxMap } from 'mapbox-gl'
import { EGeometryType, IGeometry } from '../../../filters-library/src/components/autocomplete/interfaces/geoInterfaces'


const POLYGON_KEYS = {
  maskSource: 'mask',
  maskLayer: 'mask-layer',
  zoneLineSource: 'zone-line',
  zoneLineLayer: 'zone-line'
}

export const paintLookupPolygon = (config: {
  map: MapboxMap
  geometry: IGeometry
  flyTo?: boolean
  padding?: number
}) => {
  const { map, geometry, flyTo, padding = 50 } = config

  if (!geometry?.coordinates?.length || !map) {
    return
  }

  removeLookupPolygon(map)

  const flatCoordinates =
    geometry.type === EGeometryType.MultiPolygon
      ? geometry.coordinates.map((coords) => coords[0])
      : geometry.coordinates

  if (flyTo) {
    const [minLon, minLat, maxLon, maxLat] = turfBbox({
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: flatCoordinates
      }
    } as unknown as AllGeoJSON)
    map.fitBounds(
      [
        [minLon, minLat],
        [maxLon, maxLat]
      ],
      { padding, duration: 500 }
    )
  }

  map.addSource(POLYGON_KEYS.maskSource, {
    type: 'geojson',
    data: {
      type: 'Feature',
      properties: {},
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-180, -90],
            [180, -90],
            [180, 90],
            [-180, 90],
            [-180, -90]
          ],
          ...(flatCoordinates as number[][][])
        ]
      }
    }
  })

  map.addLayer({
    id: POLYGON_KEYS.maskLayer,
    type: 'fill',
    source: POLYGON_KEYS.maskSource,
    paint: {
      'fill-color': 'rgba(0, 0, 0, 0.5)'
    }
  })

  map.addSource(POLYGON_KEYS.zoneLineSource, {
    type: 'geojson',
    data: {
      type: 'Feature',
      properties: {},
      geometry: {
        type: 'MultiLineString',
        coordinates: flatCoordinates as number[][][]
      }
    },
    lineMetrics: true
  })

  map.addLayer({
    id: POLYGON_KEYS.zoneLineLayer,
    type: 'line',
    source: POLYGON_KEYS.zoneLineSource,
    layout: {
      'line-cap': 'round',
      'line-join': 'round'
    },
    paint: {
      'line-gradient': [
        'interpolate',
        ['linear'],
        ['line-progress'],
        0,
        '#00FFF0',
        0.1,
        '#0368FE',
        0.49,
        '#02b2f7',
        1,
        '#00fff0'
      ],
      'line-width': 2
    }
  })
}

export const removeLookupPolygon = (map: MapboxMap) => {
  if (!map) {
    return
  }

  if (map?.getLayer?.(POLYGON_KEYS.maskLayer)) {
    map.removeLayer(POLYGON_KEYS.maskLayer)
    map.removeSource(POLYGON_KEYS.maskSource)
  }

  if (map?.getLayer?.(POLYGON_KEYS.zoneLineLayer)) {
    map.removeLayer(POLYGON_KEYS.zoneLineLayer)
    map.removeSource(POLYGON_KEYS.zoneLineSource)
  }
}